/* Biometric alerts tab — extracted from BiometricPunch.js (iter85).
 * Displays HR alerts (absences, tardies, incomplete punches) with severity
 * badges + a "send reminders" button. */
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { ArrowClockwise, WarningCircle } from '@phosphor-icons/react';

export const BiometricAlertsTab = ({
  today, loadAlerts, sendReminders, alertsLoading, hrAlerts,
}) => (
  <Card className="border border-[#E2E8F0] shadow-none">
    <CardContent className="p-4">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="font-outfit font-semibold">Alertes RH — {today}</h3>
          <p className="text-xs text-[#64748B]">
            Absences, retards et pointages incomplets basés sur le planning de chaque employé.
          </p>
        </div>
        <Button variant="outline" size="sm" onClick={loadAlerts} data-testid="refresh-alerts-btn">
          <ArrowClockwise size={14} className="mr-1" /> Rafraîchir
        </Button>
        <Button variant="outline" size="sm" onClick={sendReminders}
          className="border-amber-300 text-amber-700 hover:bg-amber-50 ml-2"
          data-testid="send-reminders-btn">
          🔔 Envoyer rappels
        </Button>
      </div>
      {alertsLoading ? (
        <p className="text-sm text-[#94A3B8] text-center py-6">Analyse…</p>
      ) : hrAlerts.length === 0 ? (
        <div className="p-6 text-center">
          <div className="inline-flex w-12 h-12 rounded-full bg-emerald-100 text-emerald-600 items-center justify-center mx-auto mb-2">
            ✓
          </div>
          <p className="text-sm text-[#0F172A] font-semibold">Aucune alerte — tout est à jour</p>
        </div>
      ) : (
        <div className="space-y-2">
          {hrAlerts.map((a, i) => (
            <div key={i}
              className={`p-3 rounded-md border flex items-center justify-between gap-3 ${
                a.severity === 'high' ? 'bg-red-50 border-red-200' :
                a.severity === 'medium' ? 'bg-amber-50 border-amber-200' :
                'bg-slate-50 border-slate-200'
              }`}
              data-testid={`alert-row-${a.employee_id}-${a.type}`}>
              <div className="flex items-center gap-3">
                <WarningCircle size={22} weight="duotone"
                  className={
                    a.severity === 'high' ? 'text-red-600' :
                    a.severity === 'medium' ? 'text-amber-600' : 'text-slate-500'
                  } />
                <div>
                  <div className="font-semibold text-sm">{a.employee_name}</div>
                  <div className="text-xs text-[#475569]">{a.function || a.staff_type} · {a.message}</div>
                </div>
              </div>
              <span className={`text-[10px] px-2 py-0.5 rounded-full font-bold uppercase ${
                a.severity === 'high' ? 'bg-red-200 text-red-800' :
                a.severity === 'medium' ? 'bg-amber-200 text-amber-800' :
                'bg-slate-200 text-slate-800'
              }`}>{a.severity}</span>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
